const preloadImage = imageSrc => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve();
  image.onerror = e => reject(e);
  image.src = imageSrc;
});

export default preloadImage;
